export const emptyEntity = {
  id: '',
  name: '',
  imei: '',
  user_name: '',
  subscription: '',
  business: [],
  business_id: null,
  maintenance_plan_id: null,
  odo: 0,
  short_name: '',
  active: 0,
  additional_info: '',
  entity_properties: {
    type: null,
    color: null,
    brand: null,
    model: null,
    engine_brand: null,
    engine_model: null,
    license_plate: null,
    tags: []
  },
  positioned_at: null,
  created_at: null,
  created_by_name: ''
}

export const headers = (t: ({}) => string): Header$[] => {
  return [
    {
      value: 'name',
      text: t({ s: 'name', component: 'general' }),
      sortable: false,
      width: 160
    },
    {
      value: 'imei',
      text: t({ s: 'imei', component: 'general' }),
      sortable: false
    },
    {
      value: 'short_name',
      text: t({ s: 'frameNumber', component: 'general' }),
      sortable: false
    },
    {
      value: 'type',
      text: t({ s: 'type', component: 'general' }),
      sortable: false,
      width: 80
    },
    {
      value: 'user_name',
      text: t({ s: 'user', component: 'general' }),
      sortable: false
    },
    {
      value: 'business',
      text: t({ s: 'business', component: 'general' }),
      sortable: false
    },
    {
      value: 'odo',
      text: t({ s: 'odo', component: 'general' }),
      sortable: false
    },
    {
      value: 'subscription',
      text: t({ s: 'subscription', component: 'general' }),
      sortable: false
    },
    {
      value: 'tags',
      text: t({ s: 'tags', component: 'general' }),
      sortable: false
    },
    {
      value: 'last_seen_at',
      text: t({ s: 'lastSeen', component: 'general' }),
      sortable: false,
      width: 120
    },
    {
      value: 'created_at',
      text: t({ s: 'createdAt', component: 'general' }),
      width: 120
    },
    {
      value: 'actions',
      text: t({ s: 'actions', component: 'general' }),
      sortable: false
    }
  ]
}

interface Header$ {
  value: DefaultEntityHeaderKey;
  text: string;
  width?: number;
  sortable?: boolean;
}

type DefaultEntityHeaderKey = 'name' | 'imei' | 'type' | 'user_name' | 'business' | 'odo' | 'subscription' | 'tags' | 'short_name' | 'last_seen_at' | 'created_at' | 'actions'

export const rules = {
  name: [(v: string) => !!v],
  color: [(v: string) => !!v],
  brand: [(v: string) => !!v]
}
